import { render, staticRenderFns } from "./validation-info-sidebar.vue?vue&type=template&id=7f223e56&scoped=true"
import script from "./validation-info-sidebar.vue?vue&type=script&lang=js"
export * from "./validation-info-sidebar.vue?vue&type=script&lang=js"
import style0 from "./validation-info-sidebar.vue?vue&type=style&index=0&id=7f223e56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f223e56",
  null
  
)

export default component.exports